export default "__VITE_ASSET__1SefmFx7__"